import {
  __spreadValues
} from "./chunk-D4IWIVYX.js";

// src/hooks/use-lottie-animation.hook.ts
import { useEffect as useEffect2, useState as useState2, useCallback } from "react";

// src/hooks/use-lottie.ts
import { useEffect, useState } from "react";
var useLottie = () => {
  const [lottie, setLottie] = useState(void 0);
  useEffect(() => {
    if (!lottie) {
      import("lottie-web/build/player/lottie_light").then(
        (module) => setLottie(module.default)
      );
    }
  }, [lottie]);
  return lottie;
};

// src/hooks/use-lottie-animation.hook.ts
var useLottieAnimation = ({
  lottieConfig,
  animationRef,
  animationData: animationDataPromise
}) => {
  const lottie = useLottie();
  const [containerRef, setContainerRef] = useState2(null);
  const [animation, setAnimation] = useState2(null);
  const animationContainerRef = useCallback(setContainerRef, [setContainerRef]);
  const shouldLoadAnimation = lottie && // Lottie has been loaded
  !animation && // There is no existing animation instance
  containerRef && // There is a valid container to load the animation in to
  lottieConfig && // There is a valid config with which to load the animation
  animationDataPromise;
  const loadAnimation = useCallback(
    (animationData) => {
      if (shouldLoadAnimation) {
        if (!animationData.default) {
          throw new Error(
            "animationData is not a dynamic import promise of a JSON module."
          );
        }
        const animationInstance = lottie.loadAnimation(__spreadValues({
          animationData: animationData.default,
          container: containerRef
        }, lottieConfig));
        setAnimation(animationInstance);
      }
    },
    [containerRef, lottie, lottieConfig, shouldLoadAnimation]
  );
  useEffect2(() => {
    if (shouldLoadAnimation) {
      animationDataPromise.then(loadAnimation);
    }
  }, [animationDataPromise, shouldLoadAnimation, loadAnimation]);
  useEffect2(() => {
    if (animation && animationRef) {
      animationRef.current = animation;
    }
    return () => {
      if (animation) {
        animation.destroy();
      }
    };
  }, [animation, animationRef]);
  return { animation, animationContainerRef };
};

export {
  useLottieAnimation
};
//# sourceMappingURL=chunk-2DTQ5CXV.js.map